import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/lib/swRegister";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// iter149 — Service worker (production builds only). Dev + preview skip
// registration so stale caches never block the fast feedback loop.
registerServiceWorker();
